import { Fragment } from "react";
//import Birds from "../components/Birds";
import Icons from "../components/Icons";
import Stocks from "../components/Stocks";
import SubjectLineApp from "../components/SubjectLineApp";
import ColorAnalyzer from "../components/ColorAnalyzer";
import URLDataOverlay from "../components/URLDataOverlay";
import MarketingDataCycleSimulator from "../components/MarketingDataCycleSimulator";

const CurrentProjects = () => {
  return (
    <Fragment>
      <h2>Marketing Data Cycle Simulator</h2>
      <MarketingDataCycleSimulator />

      <hr className="my-12 border-t border-slate-200" />

      <h2>Color Analyzer (D3)</h2>
      <ColorAnalyzer imageUrl="https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y29sb3J8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60" />
      <hr className="my-12 border-t border-slate-200" />

      <h2>URL Data Overlay Bookmarklet</h2>

      <URLDataOverlay />
      <hr className="my-12 border-t border-slate-200" />

      <h2>Email Subject Line Generator (AI Demo)</h2>
      <p className="mb-4">
        Intended to assist copywriters rather than replace them.
      </p>
      <SubjectLineApp />

      <hr className="my-12 border-t border-slate-200" />
      <h2>Nature Icons</h2>
      <p className="mb-4">
        I plan to share some SVG icons here. More to come.{" "}
      </p>

      <Icons />
      <hr className="my-12 border-t border-slate-200" />
      <h2>Data Visualizations (D3)</h2>
      <Stocks />
    </Fragment>
  );
};

export default CurrentProjects;
